var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card-header',[_c('div',{staticClass:"d-flex align-items-center"})]),_c('b-card-body',[_c('vue-apex-charts',{ref:"myChart",attrs:{"type":"bar","height":"325","options":_vm.data.chartOptions,"series":_vm.data.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }